import Axios from "axios";
import { url } from "../../global";
import { filter } from "underscore";

const fetchMonitoringStock = (filter) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'MONITORINGSTOCK',
            payload: Axios.get(`${url}/monitoring-stock/table`, {
                params: {
                    page: filter.page,
                    perpage: filter.perpage,
                    keyword: filter.keyword,
                    ordering: filter.ordering,
                    filter: filter.filter
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

const fetchSummary = (filter) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'GET_SUMMARY',
            payload: Axios.get(`${url}/monitoring-stock/summary`, {
                params: {
                    filter: filter.filter
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

export { fetchMonitoringStock, fetchSummary };